module.exports = __webpack_public_path__ + "0f5fcb83753e4a0c367070c144580fb4.png";